<template>
  <div class="chat-message">
    <input
      ref="file"
      type="file"
      accept="video/quicktime, video/mp4, image/png, image/jpeg, image/jpg, image/gif"
      @change="onFileChanged"
      hidden
    />
    <span @click="attachment()"><i class="fas fa-paperclip"></i></span>
    <textarea
      rows="1"
      v-model="newMessage"
      v-on:keydown.enter.exact.prevent
      v-on:keydown.enter.exact="sendMessage"
      maxlength="2000"
    />
    <b-button size="is-medium" class="section-button" @click="sendMessage">
      <i class="fas fa-paper-plane"></i>
    </b-button>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  name: 'ChatMessage',
  data() {
    return {
      newMessage: '',
      previewFile: []
    }
  },
  methods: {
    attachment() {
      this.$refs.file.click()
    },
    onFileChanged(e) {
      const file = e.target.files[0]
      let fileSizeMax // MB

      if (file.name.lastIndexOf('.') <= 0) {
        this.$parent.showAlert('File is not supported')
        return
      }

      if (file.type.startsWith('video/')) {
        // video
        fileSizeMax = 20
      } else {
        // image
        fileSizeMax = 10
      }

      const fileSize = file.size / 1024 / 1024
      if (fileSize > fileSizeMax) {
        this.$parent.showAlert(
          `The file is too large. Please select file no larger than ${fileSizeMax} MB.`
        )
        return
      }

      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = e => {
        this.previewFile.push({
          name: file.name,
          base64: e.target.result
        })
        this.$emit('previewFile', this.previewFile)

        const deliverId = `chat-upload-${uuidv4()}`
        let fileDeliverData = {
          deliverId: deliverId,
          fileName: file.name,
          fileType: file.type,
          file
        }

        this.$parent.sendMedia({
          fileDeliverData: fileDeliverData,
          fileBase64: e.target.result
        })
      }
      e.target.value = ''
    },
    sendMessage() {
      if (this.newMessage.trim()) {
        this.$parent.sendMessage(this.newMessage)
        this.newMessage = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fa-paperclip {
  font-size: 22px;
  margin: 8px 8px 0 0;

  &:hover {
    cursor: pointer;
  }
}
</style>
